import { render, staticRenderFns } from "./ModalTemplate.vue?vue&type=template&id=71798ccf&scoped=true&"
import script from "./ModalTemplate.vue?vue&type=script&lang=js&"
export * from "./ModalTemplate.vue?vue&type=script&lang=js&"
import style0 from "./ModalTemplate.vue?vue&type=style&index=0&id=71798ccf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71798ccf",
  null
  
)

export default component.exports